export default {
  data() {
    return {
      valid: {
        cost: false,
      },
      error: {
        cost: '',
      },
      errorMessages: {
        costInvalid: {
          el: 'Πρέπει να είναι αριθμός \u2265 0 με \u2264 3 δεκαδικά ψηφία',
          en: 'Must be a number \u2265 0 with \u2264 3 decimal places',
          it: 'Deve essere un numero \u2265 0 con \u2264 3 decimali',
        },
      },
    };
  },

  methods: {
    validateCost(val) {
      const num = Number(val);
      if (isNaN(num) || num < 0) {
        this.valid.cost = false;
        this.error.cost = this.errorMessages.costInvalid[this.lang];
        return false;
      }
      const str = String(val);
      const dot = str.indexOf('.');
      if (dot !== -1 && str.length - dot - 1 > 3) {
        this.valid.cost = false;
        this.error.cost = this.errorMessages.costInvalid[this.lang];
        return false;
      }
      this.valid.cost = true;
      this.error.cost = '';
      return true;
    },
  },
};
